<template>
  <div class="form-detail">
    <p class="form-item">
      <span class="form-lt">单位全称</span>
      <span class="form-rt">{{orgdetail.name}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">单位地址</span>
      <span class="form-rt">
        <span class="form-registry">{{orgdetail.cityName}}</span>
      <span class="form-registry">{{orgdetail.countyName}}</span>
      <span class="form-registry">{{orgdetail.address}}</span>
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系人</span>
      <span class="form-rt">{{orgdetail.linkMan}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系电话</span>
      <span class="form-rt">{{orgdetail.phone}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">中心坐标</span>
      <span class="form-rt">东经：{{orgdetail.longitude | formatDegree}}，北纬：{{orgdetail.latitude | formatDegree}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">所属区划</span>
      <span class="form-rt">
         <p v-for="m in orgdetail.regions" :key="m.id">
          <span class="form-registry">{{m.city.name}}</span>
      <span class="form-registry" v-for="n in m.county" :key="n.id">{{n.name}}</span>
    </p>
    </span>
    </p>
    <!-- <el-button type="info" @click="openqrcode" style="margin-top:20px;margin-left:158px">查看一企一码</el-button> -->
    <el-button type="info" style="margin-top:20px;margin-left:158px;position:relative;">
      查看一企一码
      <viewer :images="qrcodeList" class="qrcodeImg">
            <img
              v-for="(src,index) in qrcodeList"
              :src="src"
              :key="index"
            >
          </viewer>
    </el-button>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      orgdetail: {
        // 地址
        address: '',
        // 营业执照编号
        code: '',
        // 营业执照图片文件名
        imgName: '',
        //  纬度
        latitude: '',
        // 经度
        longitude: '',
        // 机构名称
        name: '',
        // 电话
        phone: '',
        // 区划
        regions: [],
        // 子类型
        subType: '',
        // 机构类型
        type: '',
        // 三级联动
        RegionPartition: [],

        legalPerson: '',

        linkMan: '',
      },
      qrcodeList:[]
    }
  },
  props: ['dataOther'],
  created() {
    // this.initdata()
    let subjectId = sessionStorage['currenOrgId']
    let qrcode = `http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`;
    this.qrcodeList.push(qrcode)
  },
  watch: {
    dataOther() {
      this.initdata()
    }
  },
  methods: {
    ...mapMutations(['DataotherForm']),
    // 初始化详情数据
    initdata() {
      if (this.dataOther) {
        this.orgdetail = JSON.parse(JSON.stringify(this.dataOther))
        this.DataotherForm(this.orgdetail)
      }
    },
    openqrcode () {
      let subjectId = sessionStorage['currenOrgId']
      window.open(`http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`)
    }
  }
}

</script>
<style lang="stylus" scoped>
.form-detail {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  color: #48576a;
  font-size: 14px;
  .form-item {
    margin-bottom: 22px;
    min-height: 36px;
    line-height: 36px;
    display: flex;
    .form-lt {
      width: 120px;
      padding-right: 12px;
      margin-right: 40px;
      box-sizing: border-box;
      text-align: right;
    }
    .form-rt {
      flex: 1;
      .form-registry {
        margin-right: 30px;
      }
      .form-region {
        padding: 5px 30px;
        border: 1px solid #48576a;
        line-height: 30px
      }
    }
  }
}

.seeBigImg {
  width:auto;
  img {
    width:180px;
  }
}

.qrcodeImg {
  position:absolute;
  top:0;
  left :0;
  right:0;
  bottom:0;
  img {
    opacity:0;
    width :100%;
    height :100%;
  }
}

</style>



// WEBPACK FOOTER //
// Otherdetail.vue?0d590a03